import { Component, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { DASHBOARD_LENDER_ATTRIBUTES, LenderAccountInfo, LenderProductAccountInfo } from "../../../../../model/finzy-flex/lender-account.model";


@Component({
    selector: 'app-expanded-products',
    templateUrl: './expanded-products.component.html',
    styleUrls: ['./expanded-products.component.scss']
})
export class ExpandedProductsComponent {
    @Input() productList: LenderProductAccountInfo[];
    @Input() backgroundColor: string;
    @Input() expansionFor: string;
    @Input() lenderAccountInfo: LenderAccountInfo;
    @Input() productVariant: Array<LenderProductAccountInfo>;
    @Output() collapseItem = new EventEmitter();

    public expanded: boolean = false;
    public selectedProduct: string;
    public selectedProductVariant: any;
    public expandedProductsHeading: string = '';

    constructor() {
    }

    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        console.log("1: ===== ", this.productList);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.manageProductHeading(changes);
    }

    public collapseExpanded(value: string) {
        return this.collapseItem.emit(value);
    }

    public onExpand(subProduct: any): void {
        this.expanded = !this.expanded;
        this.lenderSelectedProductHandler(subProduct);
    }

    public handleProductVariantView(event: string) {
        this.selectedProduct = '';
    }

    private lenderSelectedProductHandler(subProduct: {name: string, value: string}) {
        if (subProduct) {
            const getSelectedProductVariant: any = this.productVariant.find((val: any) => {
                return subProduct.name === val.productCode
            });

            switch (this.expansionFor) {
                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_ROI:
                    if(subProduct.name === this.selectedProduct) {
                        this.selectedProduct = null;
                    } else {
                        this.selectedProduct = subProduct.name;
                        this.selectedProductVariant = getSelectedProductVariant?.roiVariant ?? 0
                    }
                    break;

                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_PRINCIPLE_OUTSTANDING:
                    if(subProduct.name === this.selectedProduct) {
                        this.selectedProduct = null;
                    } else {
                        this.selectedProduct = subProduct.name;
                        this.selectedProductVariant = getSelectedProductVariant?.principalOutstandingVariant ?? 0
                    }
                    break;

                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_INTEREST_EARNED:
                    if(subProduct.name === this.selectedProduct) {
                        this.selectedProduct = null;
                    } else {
                        this.selectedProduct = subProduct.name;
                        this.selectedProductVariant = getSelectedProductVariant?.interestVariant ?? 0
                    }
                    break;
                default:
                    break;
            }
        }
    }

    private manageProductHeading(changes: SimpleChanges) {
        if(changes.expansionFor.currentValue) {
            this.expandedProductsHeading = '';
            switch (this.expansionFor) {
                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_ROI:
                    this.expandedProductsHeading = 'Aggregated Interest Rate';
                    break;
    
                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_PRINCIPLE_OUTSTANDING:
                    this.expandedProductsHeading = 'Aggregated Principal Outstanding';
                    break;
    
                case DASHBOARD_LENDER_ATTRIBUTES.EXPANDED_INTEREST_EARNED:
                    this.expandedProductsHeading = 'Aggregated Interest Earned';
                    break;
                default:
                    break;
            }
        }
    }
}